module.exports = __webpack_public_path__ + "static/img/SupandSerb.1c24c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SupandSerb.png
// module id = e9RT
// module chunks = 1